const API_URL = 'http://your-backend-api.com'; // Replace with actual URL

export const loginUser = async (credentials) => {
  const response = await fetch(`${API_URL}/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(credentials),
  });
  return response.json();
};

export const initiateProject = async (serviceData) => {
  const response = await fetch(`${API_URL}/projects`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(serviceData),
  });
  return response.json();
};

export const getProjects = async () => {
  const response = await fetch(`${API_URL}/projects`);
  return response.json();
};

export const processPayment = async (paymentData) => {
  const response = await fetch(`${API_URL}/payments`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(paymentData),
  });
  return response.json();
};

export const getPayments = async () => {
  const response = await fetch(`${API_URL}/payments`);
  return response.json();
};

export const addEvent = async (eventData) => {
  const response = await fetch(`${API_URL}/events`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(eventData),
  });
  return response.json();
};

export const getEvents = async () => {
  const response = await fetch(`${API_URL}/events`);
  return response.json();
};

export const updateProfile = async (profileData) => {
  const response = await fetch(`${API_URL}/profile`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(profileData),
  });
  return response.json();
};

export const getProfile = async () => {
  const response = await fetch(`${API_URL}/profile`);
  return response.json();
};

export const getNotifications = async () => {
  const response = await fetch(`${API_URL}/notifications`);
  return response.json();
};

export const markNotificationRead = async (id) => {
  const response = await fetch(`${API_URL}/notifications/${id}/read`, { method: 'PUT' });
  return response.json();
};

export const getRequestHistory = async () => {
  const response = await fetch(`${API_URL}/history`);
  return response.json();
};

export const sendChatMessage = async (message) => {
  const response = await fetch(`${API_URL}/chat`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ message }),
  });
  return response.json();
};

export const getChatMessages = async () => {
  const response = await fetch(`${API_URL}/chat`);
  return response.json();
};